import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Autocomplete, Button, useAutocomplete } from '@chilecompra/react-kit/components'
import { onCloseSearchBuyerPanelSuccess, onGetEntityBuyerPanelOptionsThunk } from './SearchBuyerPanel.actions'
import { Backdrop, CloseIcon, Column, Content, Form, Panel, Root, Row, Text, Title } from './SearchBuyerPanel.styles'

/**
 * The SearchBuyerPanel's container.
 */
const SearchBuyerPanel = () => {
  const dispatch = useDispatch()
  const { open, loading, options } = useSelector(state => state.searchBuyerPanel)
  const [backdropHeight, setBackdropHeight] = useState(0)
  const [selectedValue, setSelectedValue] = useState(null)
  const {
    option,
    value,
    onChange: handleChange,
    onSelect: handleSelect
  } = useAutocomplete({
    changeCallback: updatedValue => {
      if (updatedValue.length < 3) {
        return
      }

      dispatch(onGetEntityBuyerPanelOptionsThunk({ term: updatedValue }))
    },
    selectCallback: updatedOption => setSelectedValue(updatedOption?.value || null)
  })
  const handleClose = useCallback(() => dispatch(onCloseSearchBuyerPanelSuccess()), [])
  const handleSubmit = event => {
    event.preventDefault()

    if (!selectedValue || options.length === 0) {
      return
    }

    dispatch(onCloseSearchBuyerPanelSuccess())
    window.location.href = `/ficha-organismo/${selectedValue}`
  }

  useEffect(() => {
    const topNavbarElement = document.getElementById('top-navbar')

    setBackdropHeight(document.body.scrollHeight - topNavbarElement.scrollHeight)
  }, [open])

  return (
    <Root>
      {open && <Backdrop height={backdropHeight} />}
      <Panel in={open}>
        <Content>
          <Row spacing={1}>
            <Column xs={11}>
              <Title>Buscador</Title>
            </Column>
            <Column textAlign="right" xs={1}>
              <CloseIcon onClick={handleClose} />
            </Column>
          </Row>
          <Row>
            <Column xs={12}>
              <Text>Consulta la ficha de algún organismo comprador.</Text>
            </Column>
          </Row>
          <Form onSubmit={handleSubmit}>
            <Row spacing={1}>
              <Column md={10} xs={12}>
                <Autocomplete
                  option={option}
                  options={options}
                  placeholder="Ingresa el nombre del organismo, por ejemplo: “Municipalidad de Santiago”"
                  value={value}
                  waiting={loading}
                  onChange={handleChange}
                  onSelect={handleSelect}
                />
              </Column>
              <Column textAlign="center" md={2} xs={12}>
                <Button color="primary" disabled={loading || !option?.value} type="submit">
                  Buscar
                </Button>
              </Column>
            </Row>
          </Form>
        </Content>
      </Panel>
    </Root>
  )
}

export default SearchBuyerPanel
